import { render, staticRenderFns } from "./AdminFormItem.vue?vue&type=template&id=55d200c2&scoped=true"
import script from "./AdminFormItem.vue?vue&type=script&lang=js"
export * from "./AdminFormItem.vue?vue&type=script&lang=js"
import style0 from "./AdminFormItem.vue?vue&type=style&index=0&id=55d200c2&prod&lang=stylus&scoped=true"
import style1 from "./AdminFormItem.vue?vue&type=style&index=1&id=55d200c2&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d200c2",
  null
  
)

export default component.exports